import { Component, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';
import { BrandService } from 'services/brand.service';
import { NavigationService } from 'services/navigation.service';

@Component({
	selector: 'company-microsoft365-select-brand',
	templateUrl: './company-microsoft365-select-brand.component.html',
	providers: [FormValidationService],
	imports: [Layout, FormsModule, CustomSelectComponent, TranslatePipe]
})
export class CompanyMicrosoft365SelectBrandComponent {
	brands?: SelectListItemModel[];
	selectedBrandId?: string;
	productName = '';

	@Output() public brandSelected = new EventEmitter<string>();

	constructor(private readonly brandService: BrandService, private readonly navigation: NavigationService) {
		this.brands = brandService.brands?.map(b => new SelectListItemModel(b.id!, b.name));
	}

	saveChanges() {
		this.brandSelected.emit(this.selectedBrandId);
		this.close();
	}

	close() {
		this.navigation.closeView(this);
	}
}
